import { useEffect } from "react";

const CodeProtection = () => {
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Detect and discourage DevTools opening
    const handleKeyDown = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I (Inspect), Ctrl+Shift+J (Console), Ctrl+Shift+C (Element picker)
      if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j" || e.key === "C" || e.key === "c")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+S (Save page)
      if (e.ctrlKey && (e.key === "S" || e.key === "s")) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection on sensitive areas
    const handleSelectStart = (e) => {
      const el = e.target.nodeType === 1 ? e.target : e.target.parentElement;
      if (el && el.closest && el.closest("[data-protected]")) {
        e.preventDefault();
      }
    };

    // Disable drag
    const handleDragStart = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("selectstart", handleSelectStart);
    document.addEventListener("dragstart", handleDragStart);

    // Add copyright meta tag
    const meta = document.createElement("meta");
    meta.name = "copyright";
    meta.content = "Opturna Tax AI - All Rights Reserved 2026. Unauthorized reproduction or distribution is strictly prohibited.";
    document.head.appendChild(meta);

    // Console warning
    const warningStyle = "color: red; font-size: 24px; font-weight: bold;";
    const messageStyle = "color: #1e3a5f; font-size: 14px;";
    console.log("%cSTOP!", warningStyle);
    console.log("%cThis is a protected application. Unauthorized access, copying, or reverse-engineering of this software is strictly prohibited and may result in legal action under the DMCA and applicable intellectual property laws.", messageStyle);
    console.log("%cOpturna Tax AI™ - Patent Pending - All Rights Reserved 2026", messageStyle);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("dragstart", handleDragStart);
      document.head.removeChild(meta);
    };
  }, []);

  return null;
};

export default CodeProtection;
